import moment from 'moment';

import {
    formatThaiDateUi,
    getCreateDateTime
} from '../../utils/DateUtils';

export const invMasterModel = () => {
    return {
        docId: null,
        compId: null,
        docNo: null,
        docDate: formatThaiDateUi(moment()),
        docStatus: 1,
        docStatusTransport: 1,
        docStatusReceive: 1,
        docStatusPaid: null,
        docStatusPaidType: null,
        docCode: null,
        docType: null,
        docFor: null,
        docIsPickingList: null,
        docIsInv: null,
        docInvNo: null,
        docIsInvFrom: null,
        refDocId: null,
        refDoc: null,
        refDocDate: null,
        refProjectID: null,
        refProjectNo: null,
        transportType: null,
        docRemark1: null,
        docRemark2: null,
        arID: null,
        arCode: null,
        arName: null,
        docDueDate: formatThaiDateUi(moment()),
        actionHold: null,
        discountValue: 0,
        discountValueType: null,
        discountCash: 0,
        discountCashType: null,
        discountTransport: 0,
        discountTransportType: null,
        isVat: null,
        docSEQ: null,
        creditTerm: null,
        creditTerm1Day: null,
        creditTerm1Remark: null,
        creditTerm2Remark: null,
        accCode: null,
        empName: null,
        createdDate: getCreateDateTime(),
        createdByName: window.localStorage.getItem('name'),
        createdById: window.localStorage.getItem('emp_id'),
        updateDate: null,
        updateByName: null,
        updateById: null,
        approvedDate: null,
        approvedByName: null,
        approvedById: null,
        cancelDate: null,
        cancelByName: null,
        cancelById: null,
        approvedMemo: null,
        printedStatus: null,
        printedDate: null,
        printedBy: null,
        arAdd1: null,
        arAdd2: null,
        arAdd3: null,
        arProvince: null,
        arZipcode: null,
        arContact1: null,
        arContact2: null,
        arTel1: null,
        arTel2: null
    };
};